// extracted by css-extract-rspack-plugin
export default {"banner":"banner--_4Y7dcQbosk4Ds5L","limitedWidth":"limited-width--cMPy9zpmLSUaXztk","buttons":"buttons--jtS2BUfGd7Uax6L7","buttonWrapper":"button-wrapper--SsP5O21b2WUkGhLp"};